var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:_vm.$vuetify.breakpoint.mobile ? 'pa-0' : 'wrap',on:{"mousemove":function (event) { return _vm.mousemove(event, this$1); }}},[_c('div',{ref:"box"},[_c('ts-nft',{attrs:{"premint_id":_vm.premint_id,"example":_vm.nft}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }